export default __webpack_public_path__ + "static/media/menu-pizza.642a479a.png";